export type LocaleEntry = {
    description: string
    locale: string
}

export type LocaleEntries = LocaleEntry[]

export const CoreAppVersion = {
    V2: '2',
    V3: '3',
} as const

export type CoreAppVersionType = typeof CoreAppVersion[keyof typeof CoreAppVersion]

export type ServiceEntry = {
    url: string
    domain: string
    description: string
    version: CoreAppVersionType
}

export type UserLookupResponse = {
    description: string
    url: string
}

export type ServiceEntries = ServiceEntry[]
